import { clsx } from 'clsx';
import Image from '@/src/shared/components/Image';
import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import testimonials from './testimonials-data';
import {
  CarouselApi,
  CarouselV2,
  Slide,
  Arrows,
} from '@/src/shared/components/Carousel/CarouselV2';
import Link from '@/src/shared/components/Link';

const TestimonialVideo = (props) => {
  const { testimonial } = props;
  const [play, setPlay] = useState<boolean>(false);

  useEffect(() => {
    if (props.isVisible) setPlay(false);
  }, [props.isVisible]);

  return (
    <article className={clsx(styles.typeCol, styles.typeVideo)}>
      <div className={styles.videoWrapper} style={{ position: 'relative' }}>
        {play && (
          <video
            src={testimonial.video}
            playsInline
            autoPlay
            loop
            controls
          ></video>
        )}

        {!play && (
          <>
            <div className={styles.overlay} onClick={() => setPlay(true)}>
              <div className={styles.play}>
                <Image
                  width={12}
                  height={12}
                  alt="play"
                  src="/images/landing/icons/play-white.svg"
                />
              </div>
              <div>{testimonial.org}</div>
            </div>
            <Image
              fill
              src={testimonial.img}
              alt="Avatar"
              className={styles.image}
            />
          </>
        )}
      </div>
      <div className={styles.content}>
        <div className={styles.firstRow}>
          <div className={styles.testimonialContent}>{testimonial.desc}</div>
        </div>
        <div className={styles.testimonialInfo}>
          <div className={styles.testimonialFooter}>
            <span className={styles.testimonialOrg}>
              <b>{testimonial.org}</b>
            </span>
            <span className={styles.testimonialLocation}>
              <Image
                width={14}
                height={14}
                src="/images/landing/icons/icons-s-locate.svg"
                className="swiper-lazy"
                alt="Location"
              />
              &nbsp;
              {testimonial.location}
            </span>
          </div>
          <div className={styles.testimonialName}>{testimonial.name}</div>
        </div>
      </div>
    </article>
  );
};

const TestimonialSmall = (props: { testimonial1; testimonial2 }) => {
  const { testimonial1, testimonial2 } = props;
  return (
    <>
      <article className={clsx(styles.typeCol, styles.small)}>
        <div className={styles.firstRow}>
          <div className={styles.imgWrF}>
            <Image
              width="48"
              height="48"
              layout="fixed"
              src={testimonial1.img}
              alt="Avatar"
              className="swiper-lazy"
            />
          </div>
          <div className={styles.testimonialContent}>{testimonial1.desc}</div>
        </div>
        <div className={styles.testimonialInfo}>
          <div className={styles.testimonialFooter}>
            <span className={styles.testimonialOrg}>
              <b>— {testimonial1.org}</b>
            </span>
            <span className={styles.testimonialLocation}>
              <Image
                src="/images/landing/icons/icons-s-locate.svg"
                alt="Location"
                width={14}
                height={14}
                className="swiper-lazy"
              />
              &nbsp;
              {testimonial1.location}
            </span>
          </div>
          <div className={styles.testimonialName}>{testimonial1.name}</div>
        </div>
      </article>

      <article className={clsx(styles.typeCol, styles.small)}>
        <div className={styles.firstRow}>
          <div className={styles.imgWrF}>
            <Image
              width="48"
              height="48"
              layout="fixed"
              src={testimonial2.img}
              alt="Avatar"
              className="swiper-lazy"
            />
          </div>
          <div className={styles.testimonialContent}>{testimonial2.desc}</div>
        </div>
        <div className={styles.testimonialInfo}>
          <div className={styles.testimonialFooter}>
            <span className={styles.testimonialOrg}>
              <b>— {testimonial2.org}</b>
            </span>
            <span className={styles.testimonialLocation}>
              <Image
                alt="Location"
                className="swiper-lazy"
                src="/images/landing/icons/icons-s-locate.svg"
                width={14}
                height={14}
              />
              &nbsp;
              {testimonial2.location}
            </span>
          </div>
          <div className={styles.testimonialName}>{testimonial2.name}</div>
        </div>
      </article>
    </>
  );
};

const TestimonialBig = (props: { testimonial }) => {
  const { testimonial } = props;
  return (
    <>
      <article className={clsx(styles.typeCol, styles.typeSingle)}>
        <div className={styles.imgWrS}>
          <Image
            width="112"
            height="112"
            layout="fixed"
            objectPosition="center center"
            src={testimonial.img}
            alt="Avatar"
            className={styles.avatar}
          />
        </div>
        <div className={styles.content}>
          <div className={styles.firstRow}>
            <div className={styles.testimonialContent}>{testimonial.desc}</div>
          </div>
          <div className={styles.testimonialInfo}>
            <div className={styles.testimonialFooter}>
              <span className={styles.testimonialOrg}>
                <b>— {testimonial.org}</b>
              </span>
              <span className={styles.testimonialLocation}>
                <Image
                  src="/images/landing/icons/icons-s-locate.svg"
                  alt="Location"
                  width={14}
                  height={14}
                  className="swiper-lazy"
                />
                &nbsp;
                {testimonial.location}
              </span>
            </div>
            <div className={styles.testimonialName}>{testimonial.name}</div>
          </div>
        </div>
      </article>
    </>
  );
};

export default function TestimonialGrid(props: { title?: React.ReactNode }) {
  const [visibleSlides] = useState([0, 1, 2]);
  const [carouselApi, setCarouselApi] = useState<CarouselApi>(null);

  const { title } = props;

  return (
    <div className={styles.mainContainer}>
      {title ? (
        title
      ) : (
        <div className={styles.title}>Quality Content You Can Count On</div>
      )}
      <div className={styles.swiperContainerWrapper}>
        <div className={styles.swiperWrapper}>
          <CarouselV2
            getCarouselApi={setCarouselApi}
            classes={{ container: styles.carouselContainer }}
            dragFree
          >
            {testimonials?.map((item, index) => {
              return (
                <Slide
                  className={styles.slide}
                  key={`${item.id}-${item.title}`}
                >
                  {item.type == 'small' && (
                    <div className={styles.swiperSlide}>
                      <TestimonialSmall
                        testimonial1={item.children[0]}
                        testimonial2={item.children[1]}
                      />
                    </div>
                  )}

                  {item.type == 'big' && (
                    <div
                      className={clsx(styles.swiperSlide, styles.sliderSingle)}
                    >
                      <TestimonialBig testimonial={item.children[0]} />
                    </div>
                  )}

                  {item.type == 'show-more' && (
                    <Link href={'/testimonial'}>
                      <a className={clsx(styles.swiperSlide, styles.viewMore)}>
                        <span>
                          View More
                          <br />
                          Testimonials
                        </span>
                        <Image
                          src="/images/landing/icons/arrow-forward-blue.svg"
                          alt="Forward"
                          width={24}
                          height={24}
                        />
                        <div className={styles.quotation}>
                          <Image
                            src="/images/landing/quotation-mark.png"
                            alt="quotation"
                            fill
                          />
                        </div>
                      </a>
                    </Link>
                  )}

                  {item.type === 'video' && (
                    <div className={styles.swiperSlide}>
                      <TestimonialVideo
                        testimonial={item.children[0]}
                        isVisible={visibleSlides.includes(index)}
                      />
                    </div>
                  )}
                </Slide>
              );
            })}
          </CarouselV2>
          <Arrows
            carouselApi={carouselApi}
            classes={{ prev: styles.prevButton, next: styles.nextButton }}
          />
        </div>
      </div>
    </div>
  );
}
